import React, { memo } from "react";
import { Input, InputProps } from "@shared/components";
import ExtractionFieldWrapper from "@investorRequest/components/ExtractionFieldWrapper";
import { useBankExtractionForm } from "@investorRequest/components/BankExtractionFormContext";

interface Props extends Omit<InputProps, "onChange"> {
  fieldName: string;
  value: string;
  onValueChange: (value: string) => void;
}

const ExtractionAwareInput = ({ fieldName, value, onValueChange, ...inputProps }: Props) => {
  const { isActive, onFieldChange } = useBankExtractionForm();

  const input = (
    <Input
      {...inputProps}
      value={value}
      onChange={(next) => {
        onValueChange(next);

        if (isActive) {
          onFieldChange(fieldName, next);
        }
      }}
    />
  );

  if (!isActive) return input;

  return (
    <ExtractionFieldWrapper
      fieldName={fieldName}
      label={typeof inputProps.placeholder === "string" ? inputProps.placeholder : undefined}
      value={value}
      onChange={onValueChange}
    >
      {input}
    </ExtractionFieldWrapper>
  );
};

export default memo(ExtractionAwareInput);
